export default function(arg, mapArr, type = 1, extra) {

	if (type == 1) {
		// 默认按数组索引来映射
		return mapArr[new Number(arg)]
	} else if (type == 2) {
		//按属性映射,extra为数组[值,文字]
		let matchItem = mapArr.find(item => {
			return item[extra[0]] === arg
		});
		if (matchItem !== undefined) {
			return matchItem[extra[1]]
		} else {
			console.error("字典无法匹配对应值", JSON.stringify({
				arg,
				mapArr,
				extra
			}));
		}

	}

}
